import React from 'react'
import withTranslation from '../../hocs/withTranslation'
import { IStore } from '../../../store/models'
import { inject, observer } from 'mobx-react'
import { flow } from 'lodash'
import { withRouter } from 'react-router'
import DownloadsSummary from '../../admin/v2/Analytics/DownloadsSummary'

const DownloadsPage = ({ t, loaded, user, history }: FIXME) => {
  return (
    <div className='hugest-bottom'>
      <section className='pane reg-pane'>
        <div className='row'>
          <div className='col-xs-12'>
            <div className='box'>
              <DownloadsSummary height={'calc(100vh - 15rem)'} />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default flow(
  withTranslation,
  withRouter,
  observer,
  inject<FIXME, FIXME>(
    ({
      mst: {
        auth: { user, loaded }
      }
    }: {
      mst: IStore
    }) => {
      return {
        user,
        loaded
      }
    }
  )
)(DownloadsPage)
